<template>
  <div id="hres6me">
    <hrms-search-box-table v-show="indexDisp"
            v-model="searchParams"
            :data="index"
            :nowLang="app.nowLang"
            :columns="columns[app.nowLang].index"
            :receivedStore="receivedHres6meIndex"
            searchBoxAlias="request"
            :cancelEvent="cancelEvent"
            :rowDisableCondition="rowDisableCondition"
            :unLoadBool="true" />

    <detail v-show="detailDisp"
            :labels="labels[app.nowLang]"
            :labelsButton="app.button[app.nowLang]"
            :detail="detail"
            :currentDtereq="detail.dtereq"
            :currentNumseq="detail.seqno"
            :currentCodempid="codempid"
            :toggle="toggle"
            :postHres6meSaveCancel="postHres6meSaveCancel"
            :indexSelected="indexSelected"
            :nowLang="app.nowLang"
            :searchParams="searchParams"
            :descCodapp="dash.descCodapp" />
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import * as types from 'store/modules/hres6me/mutation-types'
import detail from 'components/hres6me/detail'
import moment from 'moment'
import swal from 'sweetalert'
import { constLabels } from 'assets/js/constLabels.js'

export default {
  name: 'hres6me',
  data () {
    return {
      app: this.$parent.$parent.$parent,
      dash: this.$parent.$parent.$parent.$children[0],
      dtereq: moment().format('DD/MM/YYYY'),
      searchParams: {
        dtereqst: '01' + moment().format('MM/YYYY'),
        dtereqen: moment().format('DD/MM/YYYY')
      }
    }
  },
  created () {
    this.receivedHres6meColumnsLabels()
  },
  computed: {
    codempid () {
      let currentUser = this.app.currentUser
      return currentUser.p_codempid
    },
    ...mapGetters({
      indexDisp: types.GET_HRES6ME_INDEX_DISP,
      detailDisp: types.GET_HRES6ME_DETAIL_DISP,
      columns: types.GET_HRES6ME_COLUMNS,
      labels: types.GET_HRES6ME_LABELS,
      index: types.GET_HRES6ME_INDEX,
      indexSelected: types.GET_HRES6ME_INDEX_SELECTED,
      detail: types.GET_HRES6ME_DETAIL
    })
  },
  methods: {
    pageDetail () {
      if (this.indexSelected.seqno) {
        if (this.indexSelected.staapprcc === 'A' || this.indexSelected.staapprcc === 'Y' || this.indexSelected.staapprcc === 'N') {
          swal({
            title: constLabels('warningTitle'),
            text: constLabels('HR1490'),
            confirmButtonText: constLabels('ok')
          })
        }
        let searchParams = {
          p_dtereq: this.indexSelected.dtereq,
          p_numseq: this.indexSelected.seqno
        }
        this.receivedHres6meDetail(searchParams)
        this.toggle('detail')
      }
    },
    cancelEvent (param) {
      this.setIndexSelected(param)
      this.pageDetail()
    },
    rowDisableCondition (dataRow) {
      return !(dataRow.staapprcc === 'P' || dataRow.staapprcc === '')
    },
    ...mapMutations({
      setIndexSelected: types.SET_HRES6ME_INDEX_SELECTED
    }),
    ...mapActions({
      toggle: types.TOGGLE_HRES6ME_PAGE,
      receivedHres6meColumnsLabels: types.RECEIVED_HRES6ME_COLUMNS_LABELS,
      receivedHres6meIndex: types.RECEIVED_HRES6ME_INDEX,
      receivedHres6meDetail: types.RECEIVED_HRES6ME_DETAIL,
      postHres6meSaveCancel: types.POST_HRES6ME_SAVE_CANCEL
    })
  },
  components: {
    detail
  }
}
</script>


// WEBPACK FOOTER //
// component.vue?7821f252